export default {
  title: "",
  subtitle: "Chilean Person Registration",
  path: "person_registration_cl",
  paragraph: "In Chile, the document_type will be “rut” (Rol Unico Tributario, a 9-digit number). Below you can check a payload with initial required information. For other requirements depending on payment methods, check the table 'Information needed for registration (Person)'",
  request: {
    payload: {
      "person": {
        "document_number": "173243421",
        "document_type": "rut",
        "social_name": "Marcela Carolina",
        "fiscal_country": "Chile"
      }
    },
    responses: {
      "data": {
        "updated_at": "2025-01-31TT13:33:08.286377",
        "status": "approved",
        "social_name": "Marcela Carolina",
        "required_clearance_level": 1,
        "references": [],
        "phone_number": null,
        "net_monthly_average_income": null,
        "inserted_at": "2025-01-31T13:33:08.286343",
        "id": "9fc9ad01-1b1f-466e-b50d-51cdc46fab8b",
        "fiscal_country": "Chile",
        "email": null,
        "documents": [],
        "document_type": "rut",
        "document_number": "173243421",
        "clearance_level": 1,
        "birth_date": null,
        "address_street": null,
        "address_state": null,
        "address_postal_code": null,
        "address_number": null,
        "address_country": null,
        "address_complement": null,
        "address_city": null
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectPeople/PersonRegistrationCL.js